var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download"},[_c('router-link',{attrs:{"to":{ name:'download-home'},"tag":"button"}},[_vm._v(" "+_vm._s(_vm.$t("pages.pricing.info.downloadButton"))+" ")]),_c('p',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }